// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.loading-bar {
  position: absolute;
  top: 0;
  margin-left: 0;
  height: 6px;
}

#tab-group {
  height: 100%;
}

.expansion-panel-content {
  margin: 0.5rem calc(1rem + 5px);
}

form {
  margin: 10px;
}

.dynamic-form {
  display: flex;
  justify-content: center;
}

.dialog-spinner {
  margin: 0.5rem auto;
}

.mat-mdc-dialog-content {
  overflow: hidden;
}

.copy-name-field {
  width: 100%;
}

form {
  display: flex;
  gap: var(--content-gutter);
}

.embed-button {
  padding: 0;
  position: absolute;
  top: -8px;
  right: -8px;
}

.demo-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.demo-message mat-icon {
  font-size: 96px;
  height: 96px;
  width: 96px;
}

.demo-message span {
  font-size: 16px;
  padding: 20px;
}

.demo-table {
  width: 100%;
}

input.hide-counter::-webkit-outer-spin-button,
input.hide-counter::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input.hide-counter[type=number] {
  -moz-appearance: textfield;
}

.list-header {
  padding-bottom: 5px;
  border-bottom: 1px solid #ccc;
}

app-data-viewer,
table {
  width: 100%;
}

.compact {
  height: 38px !important;
}

.compact .mat-mdc-cell,
.compact .mat-mdc-header-cell {
  font-size: 10pt;
}

.compact .mdc-data-table__cell, .mdc-data-table__header-cell {
  padding: 0;
}

.compact mat-icon {
  font-size: 15pt;
  height: 20px;
  width: 20px;
  --mat-icon-button-icon-size: 20px;
  --mat-icon-button-state-layer-size: 32px;
}

.compact mat-button-toggle mat-icon {
  font-size: 12pt;
  height: 20px;
  width: 20px;
}

::ng-deep.mat-button-toggle-label-content {
  line-height: 44px !important;
}

.mat-mdc-row .mat-mdc-cell {
  cursor: pointer;
}

.toolbar {
  margin-top: -5px;
  margin-bottom: -5px;
  height: unset !important;
}

.toolbar button {
  height: 24px;
  margin-bottom: 10px;
}

.feature-params {
  max-height: 450px;
  min-height: 200px;
}

#table-container {
  position: relative;
}

#timestamp {
  float: left;
  margin-top: 20px;
  margin-left: 10px;
}

#compose-button {
  height: 36px;
  margin-top: 8px;
}

#flyout {
  padding: 0.75rem;
  position: absolute;
  left: 260px;
  top: 15px;
  opacity: 1;
  background: white;
  z-index: 100;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.dynamic-form {
  padding-bottom: 0.75rem;
}

.full {
  height: 100%;
}

.hidden {
  box-shadow: unset !important;
  display: none !important;
}

.expander {
  margin-right: -15px;
  margin-left: 15px;
}

.candlestick {
  height: 100%;
}

.mat-expansion-panel {
  box-shadow: none !important;
  margin: 0 !important;
}

mat-list-item {
  border: none;
}

.feature-list-option {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Optional: ensures the text and icon are vertically aligned */
  cursor: pointer;
  font-size: 11pt;
}

.script-list-option {
  --mat-icon-size: 18px;
  cursor: pointer;
  gap: 0.5rem;
  font-size: 0.875rem;
  display: grid;
  align-items: center;
}
.script-list-option mat-icon {
  width: var(--mat-icon-size, 24px);
  height: var(--mat-icon-size, 24px);
  font-size: var(--mat-icon-size, 24px);
  line-height: var(--mat-icon-size, 24px);
}

.script-list-option {
  grid-template-columns: auto var(--mat-icon-size, 24px);
}

::ng-deep .mdc-tab {
  min-width: unset !important;
  padding-right: unset !important;
  padding-left: unset !important;
}

.size-button {
  position: absolute;
  left: 0px;
  top: 90px;
  color: rgba(255, 255, 255, 0.3);
  z-index: 100;
}

.relative-parent {
  position: relative;
  overflow: hidden;
}

table {
  padding: 10px;
}

.feature-output-pane {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.no-feature-selected {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--mat-sys-on-surface-variant, rgba(0, 0, 0, 0.6));
  gap: 8px;
}
.no-feature-selected mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  opacity: 0.5;
}

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.output-error {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px;
  margin: 16px;
  background: var(--mat-sys-error-container, #ffebee);
  color: var(--mat-sys-on-error-container, #c62828);
  border-radius: 4px;
}

.output-timestamp {
  padding: 8px 16px;
  font-size: 12px;
  color: var(--mat-sys-on-surface-variant, rgba(255, 255, 255, 0.7));
  flex-shrink: 0;
}

.output-table-container {
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  scrollbar-width: thin !important;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent !important;
}
.output-table-container::-webkit-scrollbar {
  width: 8px !important;
  height: 8px !important;
}
.output-table-container::-webkit-scrollbar-track {
  background: transparent !important;
}
.output-table-container::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7) !important;
  border-radius: 4px !important;
}
.output-table-container::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9) !important;
}
.output-table-container::-webkit-scrollbar-corner {
  background: transparent !important;
}
.output-table-container .output-table {
  width: 100%;
  font-size: 12px;
}
.output-table-container .output-table th, .output-table-container .output-table td {
  padding: 6px 10px;
  font-family: monospace;
}
.output-table-container .output-table th {
  background: var(--preset-card, var(--mat-sys-surface-container, #f5f5f5));
  position: sticky;
  top: 0;
  font-weight: 500;
  z-index: 1;
}

::ng-deep .output-table .mat-mdc-header-row .mat-mdc-header-cell {
  background: var(--preset-card, var(--mat-sys-surface-container, #f5f5f5)) !important;
  color: var(--mat-sys-on-surface-variant) !important;
}
::ng-deep .output-table .mat-mdc-row .mat-mdc-cell {
  color: var(--mat-sys-on-surface) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/data/explore/explore.component.scss"],"names":[],"mappings":"AA4BA;EACE,cAAA;EACA,YAAA;AA3BF;;AA8BA;EACE,kBAAA;EACA,MAAA;EACA,cAAA;EACA,WAAA;AA3BF;;AA8BA;EACE,YAAA;AA3BF;;AA8BA;EACE,+BAAA;AA3BF;;AA8BA;EACE,YAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,uBAAA;AA3BF;;AA8BA;EACE,mBAAA;AA3BF;;AA8BA;EACE,gBAAA;AA3BF;;AA8BA;EACE,WAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,0BAAA;AA3BF;;AA8BA;EACE,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AA3BF;;AA8BA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,YAAA;EACA,WAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,aAAA;AA3BF;;AA8BA;EACE,WAAA;AA3BF;;AA8BA;;EAEE,wBAAA;EACA,SAAA;AA3BF;;AA8BA;EACE,0BAAA;AA3BF;;AA8BA;EACE,mBAAA;EACA,6BAAA;AA3BF;;AA8BA;;EAEE,WAAA;AA3BF;;AA+BA;EACE,uBAAA;AA5BF;;AA+BA;;EAEE,eAAA;AA5BF;;AA+BA;EACE,UAAA;AA5BF;;AA+BA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,iCAAA;EACA,wCAAA;AA5BF;;AA+BA;EACE,eAAA;EACA,YAAA;EACA,WAAA;AA5BF;;AA+BA;EACE,4BAAA;AA5BF;;AA+BA;EACE,eAAA;AA5BF;;AA+BA;EACE,gBAAA;EACA,mBAAA;EACA,wBAAA;AA5BF;;AA+BA;EACE,YAAA;EACA,mBAAA;AA5BF;;AA+BA;EACE,iBAAA;EACA,iBAAA;AA5BF;;AA+BA;EACE,kBAAA;AA5BF;;AA+BA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;AA5BF;;AA+BA;EACE,YAAA;EACA,eAAA;AA5BF;;AA+BA;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,4EACE;AA7BJ;;AAiCA;EACE,uBAAA;AA9BF;;AAiCA;EACE,YAAA;AA9BF;;AAiCA;EACE,4BAAA;EACA,wBAAA;AA9BF;;AAiCA;EACE,mBAAA;EACA,iBAAA;AA9BF;;AAiCA;EACE,YAAA;AA9BF;;AAiCA;EACE,2BAAA;EACA,oBAAA;AA9BF;;AAiCA;EACE,YAAA;AA9BF;;AAiCA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA,EAAA,+DAAA;EACA,eAAA;EACA,eAAA;AA9BJ;;AAiCA;EACE,qBAAA;EAEA,eAAA;EACA,WAAA;EAEA,mBAAA;EAEA,aAAA;EACA,mBAAA;AAjCF;AAmCE;EACE,iCAAA;EACA,kCAAA;EACA,qCAAA;EACA,uCAAA;AAjCJ;;AAqCA;EACE,sDAAA;AAlCF;;AAqCA;EACE,2BAAA;EACA,+BAAA;EACA,8BAAA;AAlCF;;AAqCA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,+BAAA;EACA,YAAA;AAlCF;;AAqCA;EACE,kBAAA;EACA,gBAAA;AAlCF;;AAqCA;EACE,aAAA;AAlCF;;AAsCA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAnCF;;AAsCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,4DAAA;EACA,QAAA;AAnCF;AAqCE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAnCJ;;AAuCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AApCF;;AAuCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;EACA,mDAAA;EACA,iDAAA;EACA,kBAAA;AApCF;;AAuCA;EACE,iBAAA;EACA,eAAA;EACA,kEAAA;EACA,cAAA;AApCF;;AAuCA;EACE,OAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EApVA,gCAAA;EACA,gEAAA;AAiTF;AA/SE;EACE,qBAAA;EACA,sBAAA;AAiTJ;AA9SE;EACE,kCAAA;AAgTJ;AA7SE;EACE,+CAAA;EACA,6BAAA;AA+SJ;AA7SI;EACE,+CAAA;AA+SN;AA3SE;EACE,kCAAA;AA6SJ;AAoBE;EACE,WAAA;EACA,eAAA;AAlBJ;AAoBI;EACE,iBAAA;EACA,sBAAA;AAlBN;AAqBI;EACE,yEAAA;EACA,gBAAA;EACA,MAAA;EACA,gBAAA;EACA,UAAA;AAnBN;;AA4BM;EACE,oFAAA;EACA,mDAAA;AAzBR;AA6BM;EACE,2CAAA;AA3BR","sourcesContent":["// Scrollbar styling - use rgba values for reliable cross-theme support\n@mixin themed-scrollbar {\n  scrollbar-width: thin !important;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent !important;\n\n  &::-webkit-scrollbar {\n    width: 8px !important;\n    height: 8px !important;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: transparent !important;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7) !important;\n    border-radius: 4px !important;\n\n    &:hover {\n      background: rgba(155, 155, 155, 0.9) !important;\n    }\n  }\n\n  &::-webkit-scrollbar-corner {\n    background: transparent !important;\n  }\n}\n\n:host {\n  display: block;\n  height: 100%;\n}\n\n.loading-bar {\n  position: absolute;\n  top: 0;\n  margin-left: 0;\n  height: 6px;\n}\n\n#tab-group {\n  height: 100%;\n}\n\n.expansion-panel-content {\n  margin: 0.5rem calc(1rem + 5px);\n}\n\nform {\n  margin: 10px;\n}\n\n.dynamic-form {\n  display: flex;\n  justify-content: center;\n}\n\n.dialog-spinner {\n  margin: 0.5rem auto;\n}\n\n.mat-mdc-dialog-content {\n  overflow: hidden;\n}\n\n.copy-name-field {\n  width: 100%;\n}\n\nform {\n  display: flex;\n  gap: var(--content-gutter);\n}\n\n.embed-button {\n  padding: 0;\n  position: absolute;\n  top: -8px;\n  right: -8px;\n}\n\n.demo-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.demo-message mat-icon {\n  font-size: 96px;\n  height: 96px;\n  width: 96px;\n}\n\n.demo-message span {\n  font-size: 16px;\n  padding: 20px;\n}\n\n.demo-table {\n  width: 100%;\n}\n\ninput.hide-counter::-webkit-outer-spin-button,\ninput.hide-counter::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput.hide-counter[type='number'] {\n  -moz-appearance: textfield;\n}\n\n.list-header {\n  padding-bottom: 5px;\n  border-bottom: 1px solid #ccc;\n}\n\napp-data-viewer,\ntable {\n  width: 100%;\n}\n\n\n.compact {\n  height: 38px !important;\n}\n\n.compact .mat-mdc-cell,\n.compact .mat-mdc-header-cell {\n  font-size: 10pt;\n}\n\n.compact .mdc-data-table__cell, .mdc-data-table__header-cell {\n  padding: 0;\n}\n\n.compact mat-icon {\n  font-size: 15pt;\n  height: 20px;\n  width: 20px;\n  --mat-icon-button-icon-size: 20px;\n  --mat-icon-button-state-layer-size: 32px;\n}\n\n.compact mat-button-toggle mat-icon {\n  font-size: 12pt;\n  height: 20px;\n  width: 20px;\n}\n\n::ng-deep.mat-button-toggle-label-content {\n  line-height: 44px !important;\n}\n\n.mat-mdc-row .mat-mdc-cell {\n  cursor: pointer;\n}\n\n.toolbar {\n  margin-top: -5px;\n  margin-bottom: -5px;\n  height: unset !important;\n}\n\n.toolbar button {\n  height: 24px;\n  margin-bottom: 10px;\n}\n\n.feature-params {\n  max-height: 450px;\n  min-height: 200px;\n}\n\n#table-container {\n  position: relative;\n}\n\n#timestamp {\n  float: left;\n  margin-top: 20px;\n  margin-left: 10px;\n}\n\n#compose-button {\n  height: 36px;\n  margin-top: 8px;\n}\n\n#flyout {\n  padding: 0.75rem;\n  position: absolute;\n  left: 260px;\n  top: 15px;\n  opacity: 1;\n  background: white;\n  z-index: 100;\n  box-shadow:\n    0 4px 8px 0 rgba(0, 0, 0, 0.2),\n    0 6px 20px 0 rgba(0, 0, 0, 0.19);\n}\n\n.dynamic-form {\n  padding-bottom: 0.75rem;\n}\n\n.full {\n  height: 100%;\n}\n\n.hidden {\n  box-shadow: unset !important;\n  display: none !important;\n}\n\n.expander {\n  margin-right: -15px;\n  margin-left: 15px;\n}\n\n.candlestick {\n  height: 100%;\n}\n\n.mat-expansion-panel {\n  box-shadow: none !important;\n  margin: 0 !important;\n}\n\nmat-list-item {\n  border: none;\n}\n\n.feature-list-option {\n    display: flex;\n    justify-content: space-between;\n    align-items: center; /* Optional: ensures the text and icon are vertically aligned */\n    cursor:pointer;\n    font-size: 11pt;\n}\n\n.script-list-option {\n  --mat-icon-size: 18px;\n\n  cursor: pointer;\n  gap: 0.5rem;\n\n  font-size: 0.875rem;\n\n  display: grid;\n  align-items: center;\n\n  mat-icon {\n    width: var(--mat-icon-size, 24px);\n    height: var(--mat-icon-size, 24px);\n    font-size: var(--mat-icon-size, 24px);\n    line-height: var(--mat-icon-size, 24px);\n  }\n}\n\n.script-list-option {\n  grid-template-columns: auto var(--mat-icon-size, 24px);\n}\n\n::ng-deep .mdc-tab {\n  min-width: unset!important;\n  padding-right: unset!important;\n  padding-left: unset!important;\n}\n\n.size-button {\n  position: absolute;\n  left: 0px;\n  top: 90px;\n  color: rgba(255, 255, 255, 0.3);\n  z-index: 100;\n}\n\n.relative-parent {\n  position: relative;\n  overflow: hidden;\n}\n\ntable {\n  padding: 10px;\n}\n\n// Feature output pane styles\n.feature-output-pane {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.no-feature-selected {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: var(--mat-sys-on-surface-variant, rgba(0, 0, 0, 0.6));\n  gap: 8px;\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n    opacity: 0.5;\n  }\n}\n\n.loading-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n}\n\n.output-error {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 16px;\n  margin: 16px;\n  background: var(--mat-sys-error-container, #ffebee);\n  color: var(--mat-sys-on-error-container, #c62828);\n  border-radius: 4px;\n}\n\n.output-timestamp {\n  padding: 8px 16px;\n  font-size: 12px;\n  color: var(--mat-sys-on-surface-variant, rgba(255, 255, 255, 0.7));\n  flex-shrink: 0;\n}\n\n.output-table-container {\n  flex: 1;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  @include themed-scrollbar;\n\n  .output-table {\n    width: 100%;\n    font-size: 12px;\n\n    th, td {\n      padding: 6px 10px;\n      font-family: monospace;\n    }\n\n    th {\n      background: var(--preset-card, var(--mat-sys-surface-container, #f5f5f5));\n      position: sticky;\n      top: 0;\n      font-weight: 500;\n      z-index: 1;\n    }\n  }\n}\n\n// Fix sticky header background for mat-table - use opaque theme-aware colors\n::ng-deep {\n  .output-table {\n    .mat-mdc-header-row {\n      .mat-mdc-header-cell {\n        background: var(--preset-card, var(--mat-sys-surface-container, #f5f5f5)) !important;\n        color: var(--mat-sys-on-surface-variant) !important;\n      }\n    }\n    .mat-mdc-row {\n      .mat-mdc-cell {\n        color: var(--mat-sys-on-surface) !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
